import keyMirror from "keymirror";

const actions = {
  GET_DASHBOARD_OVERVIEW: null,
  GET_DASHBOARD_OVERVIEW_SUCCESS: null,
  GET_DASHBOARD_OVERVIEW_ERROR: null,
  GET_DASHBOARD_OVERVIEW_CLEAR: null,

  GET_DASHBOARD_INCOMING_OVERVIEW: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_SUCCESS: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_ERROR: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_CLEAR: null,

  GET_DASHBOARD_OVERVIEW_BAG: null,
  GET_DASHBOARD_OVERVIEW_BAG_SUCCESS: null,
  GET_DASHBOARD_OVERVIEW_BAG_ERROR: null,
  GET_DASHBOARD_OVERVIEW_BAG_CLEAR: null,

  GET_DASHBOARD_INCOMING_OVERVIEW_BAG: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_BAG_SUCCESS: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_BAG_ERROR: null,
  GET_DASHBOARD_INCOMING_OVERVIEW_BAG_CLEAR: null,

  GET_DASHBOARD_INCOMING_BAGS_CLICKABLE: null,
  GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE: null,
  GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE: null,
  GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE: null,
  GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE: null,
  GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE: null,
  GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_CLEAR: null,

  GET_DASHBOARD_INSCAN_BAGS_CLICKABLE: null,
  GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_SUCCESS: null,
  GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_ERROR: null,
  GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_CLEAR: null,
  GET_REGEX_PATTERN: null,
  GET_REGEX_PATTERN_SUCCESS: null,
  GET_REGEX_PATTERN_ERROR: null,
  GET_REGEX_PATTERN_CLEAR: null,
  GET_ANNOUNCEMENTS: null,
  GET_ANNOUNCEMENTS_SUCCESS: null,
  GET_ANNOUNCEMENTS_ERROR: null,
  GET_ANNOUNCEMENTS_CLEAR: null,
};

export default keyMirror(actions);
